module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/images/Stills_5_btspicture-c2282e29ca7e77a5095865ad03196db2.jpg";